// Hold injection: a test-only mode that deliberately causes held frames, to
// check whether the in-app logger sees holds the screen shows. Never used in
// graded runs; every run log records whether it was on.
//
//   stall   every `every` frames, the frame callback busy-waits `stallMs` on
//           the main thread (JS visibly late: the logger should see a gap)
//   gpu     every `every` frames, `layers` full-screen translucent layers are
//           drawn for `burstFrames` frames (heavy GPU fill, almost no JS
//           cost: frames can drop in the compositor while the JS callback
//           stays on time, which is what a logger can miss)
//
// tick() runs in the frame hot path: no allocation (injection times go into a
// preallocated buffer).

export const INJECT_DEFAULTS = {
    stall: { every: 30, stallMs: 25 },
    gpu: { every: 60, burstFrames: 6, layers: 200 },
}

export function createInjector(inject, { overload, spin, capacity = 4096 }) {
    if (!inject || inject.type === 'none') return null
    const times = new Float64Array(capacity)
    let count = 0
    let frame = 0
    let burstLeft = 0
    return {
        tick(t) {
            frame++
            if (burstLeft > 0) {
                burstLeft--
                if (burstLeft === 0) overload.show(false)
            }
            if (frame % inject.every !== 0) return
            if (count < capacity) times[count] = t
            count++
            if (inject.type === 'stall') {
                spin(inject.stallMs)
            } else {
                overload.show(true)
                burstLeft = inject.burstFrames
            }
        },
        end() {
            if (inject.type === 'gpu') overload.show(false)
        },
        summary() {
            const n = Math.min(count, capacity)
            const out = new Array(n)
            for (let i = 0; i < n; i++) out[i] = Math.round(times[i] * 1000) / 1000
            return { ...inject, count, frameTimesMs: out }
        },
    }
}

// Busy-wait on the main thread (the stall variant).
export function spinFor(ms, now = () => performance.now()) {
    const end = now() + ms
    while (now() < end) { /* deliberate stall */ }
}
